// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WTdCGSjXpGcXP1rcxVVK {
  color: red;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nxte-nl/error-boundary/src/ErrorBoundary.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ","sourcesContent":[".errorBoundary {\n  color: red;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorBoundary": `WTdCGSjXpGcXP1rcxVVK`
};
export default ___CSS_LOADER_EXPORT___;
